const IssueStatusLabels = {
	0: 'Ouverte',
	1: 'En cours',
	2: 'En attente du meeting',
	3: 'Meeting booké',
	4: 'Fermé',
}

export default IssueStatusLabels